import { StorageKeys } from "@utils/enums";

type SoftLoginDetails = {
    email: string | null;
    firstName: string | null;
    lastName: string | null;
};

class SoftLoginService {
    static clearSoftLogin() {
        sessionStorage.removeItem(StorageKeys.CustomerEmail);
        sessionStorage.removeItem(StorageKeys.CustomerFirstName);
        sessionStorage.removeItem(StorageKeys.CustomerLastName);
    }

    static setSoftLogin(email: string, firstName?: string) {
        if (firstName) {
            sessionStorage.setItem(StorageKeys.CustomerFirstName, firstName);
        }
        sessionStorage.setItem(StorageKeys.CustomerEmail, email);
    }

    static getSoftLoginDetails(): SoftLoginDetails {
        return {
            email: sessionStorage.getItem(StorageKeys.CustomerEmail),
            firstName: sessionStorage.getItem(StorageKeys.CustomerFirstName),
            lastName: sessionStorage.getItem(StorageKeys.CustomerLastName),
        };
    }

    static isSoftLoggedIn() {
        return !!this.getSoftLoginDetails().email;
    }
}

export { SoftLoginService };
